import React from "react";
import { toast } from "react-toastify";

import ModalLayout from "@/shared/components/Layouts/ModalLayout";
import CreateLayout from "@/shared/components/Layouts/CreateLayout";
import { UPDATE_EMPLOYEE_KPI } from "@/GraphQL/Mutation";
import { useMutation, useQuery } from "@apollo/client";
import {
  GET_EMPLOYEE_KPI_BY_EMPLOYEE_ID,
  GET_EMPLOYEE_KPI_BY_ID,
} from "@/GraphQL/Queries";

export default function KpiFeedBackModal({
  modal,
  toggle,
  userId,
  defaultData,
  type,
  kpiId,
  refetchData,
}) {
  const { data, loading, error, refetch } = useQuery(
    GET_EMPLOYEE_KPI_BY_EMPLOYEE_ID,
    {
      variables: {
        employee_id: Number(userId),
      },
      skip: !userId,
    }
  );

  const {
    data: kpiData,
    loading: kpiLoading,
    refetch: kpiRefetch,
  } = useQuery(GET_EMPLOYEE_KPI_BY_ID, {
    variables: { id: parseInt(kpiId) },
    fetchPolicy: "cache-and-network",
  });
  console.log("🚀 ~ kpiData:", kpiData?.getEmployeeKpiById);

  const [updateEmployeeKpi, { loading: updateLoading }] =
    useMutation(UPDATE_EMPLOYEE_KPI);

  const handleSubmit = async (formData) => {
    const variables = {
      dept_head_completed: formData?.dept_head_completed,
      dept_head_comment: formData?.dept_head_comment,
      employee_comment: formData?.employee_comment,
      employee_completed: formData?.employee_completed,
      id: parseInt(kpiId),
    };

    try {
      if (type === "dept") {
        await updateEmployeeKpi({
          variables,
        });
        refetch();
        refetchData();
        toast.success("Department feedback saved successfully!");
      } else if (type === "kpi") {
        await updateEmployeeKpi({
          variables,
        });
        refetch();
        refetchData();
        toast.success("Employee KPI feedback saved successfully!");
      }

      toggle();
    } catch (err) {
      console.error("Submission error:", err);
      toast.error("Failed to save feedback.");
    }
  };

  const forms =
    type === "dept"
      ? [
          {
            name: "dept_head_comment",
            placeholder: "Department Head Comment",
            rules: () => ({ required: "This is required field" }),
            label: "Department Head Comment",
            type: "text",
            deviceSize: 12,
            defaultValue: kpiData?.getEmployeeKpiById?.dept_head_comment || "",
          },
          {
            name: "dept_head_completed",
            placeholder: "Target Value",
            rules: () => ({ required: "This is required field" }),
            label: "Target Value",
            type: "number",
            deviceSize: 12,
            defaultValue:
              kpiData?.getEmployeeKpiById?.dept_head_completed || "",
          },
        ]
      : [
          {
            name: "employee_comment",
            placeholder: "Employee Comment",
            rules: () => ({ required: "This is required field" }),
            label: "Employee Comment",
            type: "text",
            deviceSize: 12,
            defaultValue: kpiData?.getEmployeeKpiById?.employee_comment || "",
          },
          {
            name: "employee_completed",
            placeholder: "Completed Value",
            rules: () => ({ required: "This is required field" }),
            label: "Completed Value",
            type: "number",
            deviceSize: 12,
            defaultValue:
              kpiData?.getEmployeeKpiById?.employee_completed ||
              "defaultData?.name",
          },
        ];

  return (
    <ModalLayout
      style={{ maxWidth: "500px", width: "100%" }}
      className="modal-sm-custom"
      modal={modal}
      toggle={toggle}
    >
      {/* <div
        className="p-3 mb-3 bg-light rounded border d-flex justify-content-between align-items-center"
        style={{ maxWidth: "400px" }}
      >
        <div>
          <h6 className="mb-1 text-primary">🎯 Total KPI Target</h6>
      
        </div>
        <div>
          <h6 className="mb-1 text-success">✅ Completed</h6>
          <h5 className="mb-0 fw-bold">20</h5>
        </div>
      </div> */}
      <CreateLayout
        onSubmit={handleSubmit}
        forms={forms}
        toggle={toggle}
        submitText={defaultData?.id ? "Update" : "Add"}
      />
    </ModalLayout>
  );
}
